import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-all-chairmans',
  templateUrl: './all-chairmans.component.html',
  styleUrls: ['./all-chairmans.component.scss']
})
export class AllChairmansComponent implements OnInit, OnDestroy {
  Chairmans: any;
  fetchinData = true;
  private ngUnsubscribe = new Subject();

  constructor(private appService: AppService, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.FetchChairmans();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchChairmans() {
    this.fetchinData = true;
    forkJoin([
      this.appService.getContents(),
    ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      const allData = response[0].data || [];
      this.Chairmans = allData.filter((x: any) => x.ContentCategoryName === 'All-Chairmans');
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }
}
